import { Component, Inject, Input, ViewEncapsulation } from "@angular/core";
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from "angular-l10n";

@Component({
  selector: "header",
  templateUrl: "header.template.html",
  styleUrls: ["header.style.less"],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() message: string = "";

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private translation: L10nTranslationService) {}

  public changeLanguage(language: string): void {
    this.translation.setLocale({language});
    localStorage.setItem("currentLanguage", language.toLowerCase());
  }
}
